export type { ConnectionState, MessageHandler } from './WebSocketManager';
export { WebSocketManager, wsManager } from './WebSocketManager';
export {
  DEFAULT_REQUEST_TIMEOUT_MS,
  createRequestTimers,
  timeoutError,
  type RequestTimers,
} from './requestTimeout';
export {
  sendRequest,
  RequestError,
  OfflineQueueFullError,
  rateLimitRefusal,
  type SendRequestOptions,
} from './requestResponse';
